import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  RecordDiscountInteractionRequestObjectType,
  RecordDiscountInteractionResponseType
} from '../../../services/NwApplicationServices/APIService/types';

import { useNwApplicationService } from '../useNwApplicationService';

interface UseRecordDiscountInteractionInterface {
  recordDiscountInteractionApi: UseMutateAsyncFunction<
    RecordDiscountInteractionResponseType,
    Error,
    RecordDiscountInteractionRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useRecordDiscountInteractionApi =
  (): UseRecordDiscountInteractionInterface => {
    const { nwApplicationService } = useNwApplicationService();

    const recordDiscountInteraction = (
      requestObject: RecordDiscountInteractionRequestObjectType
    ) => {
      return nwApplicationService.recordDiscountInteraction(requestObject);
    };

    const { mutateAsync, error, status } = useMutation(
      recordDiscountInteraction,
      {
        mutationKey: ['recordDiscountInteractionApi']
      }
    );

    const recordDiscountInteractionApi = mutateAsync;

    return {
      recordDiscountInteractionApi,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useRecordDiscountInteractionApi };
